export const extendUrl3D = {
    url: process.env.REACT_APP_URL_3D || "https://tool3d-staging-mcvn.merchize.com"
}

export const extendUrlFactory = {
    url: process.env.REACT_APP_URL_FACTORY || "https://f1-staging-mcvn.merchize.com"
}

export const extendUrlFulfillment = {
    url: process.env.REACT_APP_URL_FFM || "https://fulfillment-staging.merchize.com"
}
